'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');
var arrow_up_inline = require('../../assets/svg/arrow_up.inline.svg.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var ScrollToTop = function ScrollToTop(props) {
  var appearHeight = props.appearHeight,
    blue = props.blue,
    bottom = props.bottom,
    idToFocus = props.idToFocus,
    classes = props.classes;
  var _useState = React.useState(false),
    _useState2 = slicedToArray.default(_useState, 2),
    showScroll = _useState2[0],
    setShowScroll = _useState2[1];
  var buttonClasses = index.default('scroll-btn', classes, {
    'scroll-btn--show': showScroll,
    'scroll-btn--bottom': bottom,
    'scroll-btn--blue': blue
  });
  React.useEffect(function () {
    var height = appearHeight !== null && appearHeight !== void 0 ? appearHeight : window.innerHeight;
    var scrollBtnVis = function scrollBtnVis() {
      window.pageYOffset > height ? setShowScroll(true) : setShowScroll(false);
    };
    window.addEventListener('scroll', scrollBtnVis);
    return function () {
      return window.removeEventListener('scroll', scrollBtnVis);
    };
  }, []);
  var handleScroll = function handleScroll(e) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setTimeout(function () {
      document.getElementById(idToFocus).focus();
    }, 100);
  };
  return /*#__PURE__*/React__default.default.createElement("button", {
    "aria-hidden": true,
    tabIndex: -1,
    onClick: handleScroll,
    className: buttonClasses
  }, /*#__PURE__*/React__default.default.createElement(arrow_up_inline.default, null));
};
ScrollToTop.propTypes = {
  appearHeight: PropTypes__default.default.number,
  blue: PropTypes__default.default.bool,
  bottom: PropTypes__default.default.bool,
  classes: PropTypes__default.default.string,
  idToFocus: PropTypes__default.default.string
};
ScrollToTop.defaultProps = {
  blue: false,
  bottom: false,
  idToFocus: 'gatsby-focus-wrapper',
  classes: ''
};

exports.ScrollToTop = ScrollToTop;
exports.default = ScrollToTop;
//# sourceMappingURL=ScrollToTop.js.map
